import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import { APP_URL, STATIC_URL } from '../../config'

import { useActiveWeb3React } from 'hooks/web3'
import { useBlockNumber } from 'state/application/hooks'

import { ExplorerDataType, getExplorerLink } from 'utils/getExplorerLink'

const Footer: FC = () => {
  const { chainId } = useActiveWeb3React()
  const blockNumber = useBlockNumber()

  return (
    <footer className="web-footer">
      <main>
        <a
          className="status connect"
          href={chainId && blockNumber ? getExplorerLink(chainId, blockNumber.toString(), ExplorerDataType.BLOCK) : ''}
        >
          <Trans>FooterOperational</Trans>
        </a>
        <span>XDX &copy; 2024</span>
        <hr />
      </main>
      <div className="web-footer-links">
        <a href={APP_URL + 'paper/terms'}>
          <img src={STATIC_URL + 'icon/document.svg'} alt="" />
          <Trans>FooterTermsOfUse</Trans>
        </a>
        <a href={APP_URL + 'paper/privacy'}>
          <img src={STATIC_URL + 'icon/safe.svg'} alt="" />
          <Trans>FooterPrivacyPolicy</Trans>
        </a>
      </div>
    </footer>
  )
}

export default Footer
